<template>
  <div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import auth from '@/auth'
import { initAxios, axiosInstance } from '@/api'


export default {
  name: "Callback",
  data() {
    return {
      loading: true,
      path: ""
    }
  },
  mounted() {
    auth.login()
    
    if (this.$route.query.hasOwnProperty('path')) {
      this.path = this.$route.query.path
    }
  },
  computed: mapState(['isAuthenticated']),
  watch: {
    isAuthenticated(newValue, oldValue) {
      if (newValue === true) {
        // ### Change the routing decition here.
        this.$router.push({ name: 'Home' })
        return
      }
    },
  },
}
</script>
